import { render, staticRenderFns } from "./commonBarButton.vue?vue&type=template&id=71721fc7&scoped=true"
var script = {}
import style0 from "./commonBarButton.vue?vue&type=style&index=0&id=71721fc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71721fc7",
  null
  
)

export default component.exports